import * as angular from "angular";
import viewModesSection from "./view-modes-section";
import viewModesMode from "./view-modes-mode";
import viewModeAction from "./view-mode-action";
import viewModeFallback from "./view-mode-fallback";

export default angular
	.module("vesl.components.view-modes-section", [
		viewModesSection,
		viewModesMode,
		viewModeAction,
		viewModeFallback
	])
	.name;
